import { render, staticRenderFns } from "./DealSummary.vue?vue&type=template&id=1d493a0e&scoped=true&"
import script from "./DealSummary.vue?vue&type=script&lang=js&"
export * from "./DealSummary.vue?vue&type=script&lang=js&"
import style0 from "./DealSummary.vue?vue&type=style&index=0&id=1d493a0e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d493a0e",
  null
  
)

export default component.exports